import { useSelector } from "../../../../redux-store";
import { selectClient } from "../../../../ducks/data/clients/selectors";
import { useTranslation } from "react-i18next";

const SelectedClientDetails = (props: { selectedClientId?: string | null }) => {
  const { t } = useTranslation(["shipmentModal"]);
  const selectedClient = useSelector(selectClient(props.selectedClientId));

  return selectedClient ? (
    <div className="text-gray-500 flex flex-col gap-1" style={{ fontSize: 14 }}>
      <div>
        {t("shipmentModal:email")}: {selectedClient.clientEmail}
      </div>
      <div>
        {t("shipmentModal:phone")}: {selectedClient.clientPhone}
      </div>
      <div>
        {t("shipmentModal:address")}: {selectedClient.clientAddress}
      </div>
    </div>
  ) : null;
};

export default SelectedClientDetails;
